import { Component, Input } from '@angular/core';

interface ArrowLink {
  label: string;
  link: string;
}

interface ArrowRouterLink {
  label: string;
  routerLink: string;
}

export type ArrowLinkConfig = ArrowLink | ArrowRouterLink;

@Component({
  selector: 'app-arrow-links',
  templateUrl: './arrow-links.component.html',
  styleUrls: ['./arrow-links.component.scss'],
})
export class ArrowLinksComponent {
  @Input() links: ArrowLinkConfig[];
}
